import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { keys, sortBy } from 'lodash'
import Select from 'react-select'
import './index.css'


const menuStyle ={
  backgroundColor:'#fff',
  padding: '2px 0',
  magin: '0px',
  position: 'absolute',
  overflow: 'auto',
  color: "#222",
  width: "100%",
  fontSize: '14px',
  border: "solid #ccc 1px",
  borderTop: "none",
}

class DataExplorerIndex extends React.Component {

  handleCountryChange = (item) => {
    this.props.history.push(`/countries/${item.value}`)
  }

  handleIndicatorChange = (item) => {
    this.props.history.push(`/topics/${item.value}`)
  }

  render() {
    const { countries, indicators } = this.props
    const countryOptions = sortBy(keys(countries).map(c => ({label: countries[c], value: c})), i => i.label)
    const indicatorsOptions = sortBy(keys(indicators)
      .filter(i=>indicators[i].domain)
      .map(c => ({label: indicators[c].title, value: c})), i => i.label)

    return (
      <div className="Home">
        <div>
            <div className="fl-l w-50-l w-100 pa2">
              <h3 className="ml4"><Link to="/countries" className="no-underline underline-hover text-orange">Countries</Link></h3>
              {/* <p className="text-blue ml4">
                <Link className="no-underline underline-hover text-blue" to="/third-pillar">
                  Explore the current status of the Trade Facilitation in the World
                </Link>
              </p> */}
              <Link to="/countries">
                <div className="center pa2 dt DataExplorer__Preview border-blue DataExplorer__Preview--border">
                  <div className="v-mid dtc tc">
                    <img src="/covers/cover1.png" className="" alt="Countries cover"/>
                  </div>
                </div>
              </Link>
            <div className="pa2">
              <div className="mt3 ph3 text-blue">
                <Select
                  menuStyle={menuStyle}
                  className="Home__Select"
                  name="select_focus"
                  placeholder={'Select country'}
                  clearable={true}
                  options={countryOptions}
                  onChange={this.handleCountryChange}
                />
              </div>
            </div>
            </div>
            <div className="fl-l w-50-l w-100 pa2">
              <h3 className="ml4"><Link to="/topics" className="no-underline underline-hover text-orange">Topics and Unit of Analysis</Link></h3>
              {/* <p className="text-blue ml4">
                <Link className="no-underline underline-hover text-blue" to="/third-pillar">
                  Explore the current status of the Trade Facilitation in the World
                </Link>
              </p> */}
              <Link to="/topics">
                <div className="center pa2 dt DataExplorer__Preview border-blue DataExplorer__Preview--border">
                  <div className="v-mid dtc tc">
                    <img src="/covers/cover3.png" className="" alt="Topics cover"/>
                  </div>
                </div>
              </Link>
              <div className="pa2">
                <div className="mt3 ph3 text-blue">
                  <Select
                    menuStyle={menuStyle}
                    className="Home__Select"
                    name="select_focus"
                    placeholder={'Select indicator'}
                    clearable={true}
                    options={indicatorsOptions}
                    onChange={this.handleIndicatorChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>


    )
  }
}

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
})
export default connect(mapStateToProps)(DataExplorerIndex)



// WEBPACK FOOTER //
// ./src/pages/DataExplorerIndex/index.js